import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackAddAllItemsAndCheckoutParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackAddAllItemsAndCheckout";

const useTrackAddAllItemsAndCheckout = (
    parameters: TrackAddAllItemsAndCheckoutParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.addAllItemsAndCheckout, parameters, options);
};

export default useTrackAddAllItemsAndCheckout;
